const styles = {
    bold: {
        fontWeight: 'bold'
    },
    media: {
        width: '100%'
    }
};

export default styles;
